module.exports = __webpack_public_path__ + "static/media/element3.ef657414.svg";